import {
  getDashboardLabel,
  RiskScoreEnum,
  TransactionStatusEnum,
  TransactionTypeEnum,
  TransactionOwnerEnum,
} from '@sparling/financial-common'
import { IColumns } from '../../../../components/Dashboard/TableSmall'

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: 'transactions-history-by-user',
  columns: [
    {
      id: 'type',
      label: 'TYPE',
      format: (value: string) => value.replace(/\b[a-z]/g, (match: string) => match.toUpperCase()),
    },
    {
      id: 'amount',
      label: 'AMOUNT',
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      /*      format: (value: number) => {
        const newValue = value.toFixed(2).toString().split('.')
        newValue[0] = newValue[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        return `$${newValue.join(',')}`
      }, */
    },
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'status',
      label: 'STATUS',
      format: (status, owner, type, score) =>
        getDashboardLabel(
          owner as TransactionOwnerEnum,
          status as TransactionStatusEnum,
          type as TransactionTypeEnum,
          score as RiskScoreEnum,
        ),
    },
    {
      id: 'action',
      label: 'ACTION',
    },
  ],
}
